const reviseItemTypes = [
  { value: "iata-aruana", name: "Сверка Iata-Aruana" },
  { value: "aruana-kayar", name: "Сверка Aruana-Kayar" },
  { value: "silk-kayar", name: "Сверка Silk-Kayar" }
];

export default reviseItemTypes;

